import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

export function useCohortEnrollments(isAdmin) {
  const [cohortEnrollments, setCohortEnrollments] = useState([]);
  const [loadingCohortEnrollments, setLoadingCohortEnrollments] = useState(false);

  const fetchCohortEnrollments = async () => {
    if (!isAdmin) return;

    setLoadingCohortEnrollments(true);

    const { data, error } = await supabase
      .from("cohort_enrollments")
      .select(
        "id, cohort_id, user_id, enrollment_status, enrollment_source, notes, enrolled_at, updated_at"
      )
      .order("enrolled_at", { ascending: false });

    if (error) {
      alert(error.message);
      setLoadingCohortEnrollments(false);
      return;
    }

    setCohortEnrollments(data || []);
    setLoadingCohortEnrollments(false);
  };

  const enrollStudentInCohort = async ({
    cohortId,
    studentUserId,
    enrollmentSource,
    notes,
  }) => {
    if (!cohortId || !studentUserId) {
      alert("Please select cohort and student.");
      return false;
    }

    const { error } = await supabase.from("cohort_enrollments").insert({
      cohort_id: cohortId,
      user_id: studentUserId,
      enrollment_status: "active",
      enrollment_source: enrollmentSource || "manual_admin",
      notes: notes || null,
    });

    if (error) {
      alert(error.message);
      return false;
    }

    alert("Student enrolled in cohort.");
    await fetchCohortEnrollments();
    return true;
  };

  const updateCohortEnrollmentStatus = async (enrollmentId, status) => {
    if (!enrollmentId || !status) return false;

    const { error } = await supabase
      .from("cohort_enrollments")
      .update({
        enrollment_status: status,
        updated_at: new Date().toISOString(),
      })
      .eq("id", enrollmentId);

    if (error) {
      alert(error.message);
      return false;
    }

    alert("Enrollment updated.");
    await fetchCohortEnrollments();
    return true;
  };

  useEffect(() => {
    fetchCohortEnrollments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);

  return {
    cohortEnrollments,
    loadingCohortEnrollments,
    fetchCohortEnrollments,
    enrollStudentInCohort,
    updateCohortEnrollmentStatus,
  };
}